import React, { useState, useEffect } from 'react';
import { ProfileModal, ProfileDetails, ContactInformation, PasswordManagement } from '../components/Profile';
import { employeeService } from '../services/mpapi';
import { useToast } from '../components/Admissionform/ToastManager';
import '../styles/MyProfile.css';

const MyProfile = ({ onClose }) => { // Accept onClose prop
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const { showSuccess, showError } = useToast();


  useEffect(() => {
    fetchEmployeeData();
  }, []); // Remove showModal dependency since component only renders when needed

  const fetchEmployeeData = async () => {
    setLoading(true);
    setError(null);
    try {
      const userData = await employeeService.getEmployeeProfile();
      setEmployee(userData);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch employee data');
      console.error('Error fetching employee data:', err);
      setLoading(false);
    }
  };

  const handleProfileUpdate = async (formData) => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      await employeeService.updateEmployeeProfile({
        emp_id: employee.emp_id,
        ...formData
      });
      // Update local state with new data
      setEmployee({
        ...employee,
        ...formData
      });
      setSuccess('Profile updated successfully');
      setLoading(false);
    } catch (err) {
      setError('Failed to update profile');
      console.error('Error updating profile:', err);
      setLoading(false);
    }
  };

  const handlePasswordChange = async (passwordData) => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    // Check if new password and confirm password match
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setError('New password and confirm password do not match');
      setLoading(false);
      return;
    }

    try {
      await employeeService.changePassword(passwordData);
      showSuccess('Password changed successfully');
      handleClose();
      setLoading(false);
    } catch (err) {
      // Check if the error is due to incorrect old password
      if (err.response && err.response.status === 401) {
        showError('Old password is incorrect');
      } else {
        showError('Failed to change password');
      }
      console.error('Error changing password:', err);
      setLoading(false);
    }
  };

  const handleClose = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <ProfileModal
      isOpen={true} // Always open when component renders
      onClose={handleClose}
      title={employee?.emp_name || "Loading..."}
      loading={loading}
      error={error}
      success={success}
    >
      {employee && (
        <div className="profile-details">
          <ProfileDetails employee={employee} />

          <ContactInformation
            employee={employee}
            onUpdate={handleProfileUpdate}
            loading={loading}
          />

          <PasswordManagement
            employeeId={employee.emp_id}
            onChangePassword={handlePasswordChange}
            loading={loading}
          />
        </div>
      )}
    </ProfileModal>
  );
};

export default MyProfile;